export const TABS = {
	GENERAL_INFORMATION: 'general_information',
	TAX_INFORMATION: 'tax_information'
};
